import React, { Component } from 'react';
import Top_Bar from '../../Part_Sample/Top_Bar';
import Editbox from '../../Part_Sample/Editbox';
import Price_Timezone from '../../Part_Sample/Price_Timezone';
import Unit_Price_Chart from '../../Part_Sample/Unit_Price_Chart';
import { Colours } from '../../Common/colours';

export default class Unit_Price_Settings extends Component {
	constructor(props) {
		super(props);
		let price_info = this.props.param.price_info;
		if (Object.keys(price_info).length === 0) { //Check for empty object
			price_info.currency = 'S$';
			price_info.zone = {
				weekday: {
					zone1: { name: "", period: [0, 2400], price: [0, 0], enable: false },
					zone2: { name: "", period: [0, 2400], price: [0, 0], enable: false },
					zone3: { name: "", period: [0, 2400], price: [0, 0], enable: false },
					zone4: { name: "", period: [0, 2400], price: [0, 0], enable: false },
					zone5: { name: "", period: [0, 2400], price: [0, 0], enable: false },
				}, holiday: {
					zone1: { name: "", period: [0, 2400], price: [0, 0], enable: false },
					zone2: { name: "", period: [0, 2400], price: [0, 0], enable: false },
					zone3: { name: "", period: [0, 2400], price: [0, 0], enable: false },
					zone4: { name: "", period: [0, 2400], price: [0, 0], enable: false },
					zone5: { name: "", period: [0, 2400], price: [0, 0], enable: false },
				}
			};
		}

		this.state = {
			currency: price_info.currency,
			weekday: price_info.zone.weekday,
			holiday: price_info.zone.holiday,
			tab: "weekday" //default tab
		}
		this.price_info = price_info;
	}

	handlePrevious = () => {
		window.app.content_area.current.switch_content.current.bottom_controls_ref.current.handleHolidaySettings(false);
		window.app.content_area.current.switch_content.current.handleHideBottomMenu();
		this.props.content_handler('Billing_Main');
	}

	handleChangeCurrency = (currency) => {
		this.setState({ currency: currency })
	}

	handleChangeName = ({ name, zone, type }) => {
		if (type == 'weekday') {
			let weekday_info = this.state.weekday;
			weekday_info[zone].name = name;
			this.setState({
				weekday: weekday_info
			})
		} else {
			let holiday_info = this.state.holiday;
			holiday_info[zone].name = name;
			this.setState({
				holiday: holiday_info
			})
		}
	}

	handleChangeStartTimeZone = ({ start_time_zone, zone, type }) => {

		let info = {};
		if (type == 'weekday') info = this.state.weekday;
		else info = this.state.holiday;

		if (start_time_zone > info[zone].period[1]) {
			window.app.showToast(this.props.receiver.getString('start_time_later_than_end_time'), 3000);
		} else {
			info[zone].period[0] = start_time_zone;
			if (type == 'weekday') this.setState({ weekday: info })
			else this.setState({ holiday: info })
		}
	}

	handleChangeEndTimeZone = ({ end_time_zone, zone, type }) => {

		let info = {};
		if (type == 'weekday') info = this.state.weekday;
		else info = this.state.holiday;

		if (end_time_zone < info[zone].period[0]) {
			window.app.showToast(this.props.receiver.getString('end_time_earlier_than_start_time'), 3000);
		} else {
			info[zone].period[1] = end_time_zone;
			if (type == 'weekday') this.setState({ weekday: info })
			else this.setState({ holiday: info })
		}
	}

	handleChangeUnitPrice = ({ unit_price, zone, type }) => {

		let info = {};
		if (type == 'weekday') info = this.state.weekday;
		else info = this.state.holiday;

		info[zone].price[0] = unit_price;

		if (type == 'weekday') this.setState({ weekday: info })
		else this.setState({ holiday: info })

	}

	handleToggleSwitch = ({ is_enabled, zone, type }) => {

		let info = {};
		if (type == 'weekday') info = this.state.weekday;
		else info = this.state.holiday;

		info[zone].enable = is_enabled;

		if (type == 'weekday') this.setState({ weekday: info })
		else this.setState({ holiday: info })
	}

	// Save Unit Price Settings
	handleRegister = () => {

		if (this.state.currency === "") {
			window.app.showToast(this.props.receiver.getString('set_fail'), 3000);
			return;
		}

		this.price_info.currency = this.state.currency;

		let weekday_info = this.state.weekday;
		for (let weekday_key in weekday_info) { //for every price value, convert to numbers
			let price_info = weekday_info[weekday_key].price;

			if (price_info[0] === "") {
				window.app.showToast(this.props.receiver.getString('set_fail'), 3000);
				return;
			}

			weekday_info[weekday_key].price[0] = parseFloat(price_info[0]);
			weekday_info[weekday_key].price[1] = parseFloat(price_info[1]);
		}
		this.price_info.zone.weekday = weekday_info;

		let holiday_info = this.state.holiday;
		for (let holiday_key in holiday_info) { //for every price value, convert to numbers
			let price_info = holiday_info[holiday_key].price;

			if (price_info[0] === "") {
				window.app.showToast(this.props.receiver.getString('set_fail'), 3000);
				return;
			}

			holiday_info[holiday_key].price[0] = parseFloat(price_info[0]);
			holiday_info[holiday_key].price[1] = parseFloat(price_info[1]);
		}
		this.price_info.zone.holiday = holiday_info;
		this.props.receiver.savePriceInfo(this.price_info);
	}

	// Response from saving price information
	rcvSavePriceInfo = (response) => {
		if (response != null && response.result == 'OK') this.handlePrevious();
	}

	// Change tab -> Weekday | Holiday
	handleShowPriceInfo = (tab) => {
		//show calendar and dow settings only if holiday tab is active
		if (tab == 'holiday') window.app.content_area.current.switch_content.current.bottom_controls_ref.current.handleHolidaySettings(true);
		else window.app.content_area.current.switch_content.current.bottom_controls_ref.current.handleHolidaySettings(false);
		this.setState({ tab: tab })
	}

	// Response from loading of holiday calendar
	rcvLoadHolidayCalendar = (holiday_info) => {
		window.app.hideLoading();
		window.app.content_area.current.switch_content.current.handleShowBottomControls();
		if (this.navigation == "holiday_calendar") this.props.content_handler('Holiday_Calendar_Settings', { holiday_info: holiday_info });
		else this.props.content_handler('Holiday_DOW_Settings', { holiday_info: holiday_info });
	}

	// Access Holiday Calendar settings
	handleLeftButtonAction = () => {
		window.app.showLoading();
		this.navigation = "holiday_calendar";
		this.props.receiver.loadHolidayCalendar();
	}

	// Access Holiday Day Of The Week Settings
	handleLeftButton2Action = () => {
		window.app.showLoading();
		this.navigation = "holiday_dow";
		this.props.receiver.loadHolidayCalendar();
	}

	render() {

		let style = {
			textAlign: 'center',
			width: '100%',
		}

		let main_content_style = {
			position: 'fixed',
			top: 0,
			width: '100%',
			height: this.props.height,
		}

		let unit_price_timezone_style = {
			overflow: 'auto'
		}

		let unit_price_chart_style = {
			height: 'auto',
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
			marginLeft: 20,
			marginRight: 20,
			marginTop: 20,
			padding: 10
		}

		let dynamic_content = null;
		let dynamic_price_chart = null;

		switch (this.state.tab) {
			case 'weekday':
				dynamic_content =
					<div id="unit_price_day_timezone" style={unit_price_timezone_style}>
						{Object.keys(this.state.weekday).map((zone, index) => {
							return (
								<Price_Timezone
									type={"weekday"}
									zone={zone}
									priority={index + 1}
									is_enabled={this.state.weekday[zone].enable}
									name_placeholder={this.props.receiver.getString('name')}
									name={this.state.weekday[zone].name}
									handleChangeName={this.handleChangeName}
									unit_price={this.state.weekday[zone].price[0]}
									unit_price_placeholder={this.props.receiver.getString('unit_price')}
									currency={this.state.currency}
									start_time_zone={this.state.weekday[zone].period[0]}
									end_time_zone={this.state.weekday[zone].period[1]}
									handleChangeStartTimeZone={this.handleChangeStartTimeZone}
									handleChangeEndTimeZone={this.handleChangeEndTimeZone}
									handleChangeUnitPrice={this.handleChangeUnitPrice}
									handleToggleSwitch={this.handleToggleSwitch}
								/>
							)
						})}
					</div>
				break;
			case 'holiday':
				dynamic_content =
					<div id="unit_price_day_timezone" style={unit_price_timezone_style}>
						{Object.keys(this.state.holiday).map((zone, index) => {
							return (
								<Price_Timezone
									type={"holiday"}
									zone={zone}
									priority={index + 1}
									is_enabled={this.state.holiday[zone].enable}
									name_placeholder={this.props.receiver.getString('name')}
									name={this.state.holiday[zone].name}
									handleChangeName={this.handleChangeName}
									unit_price={this.state.holiday[zone].price[0]}
									unit_price_placeholder={this.props.receiver.getString('unit_price')}
									currency={this.state.currency}
									start_time_zone={this.state.holiday[zone].period[0]}
									end_time_zone={this.state.holiday[zone].period[1]}
									handleChangeStartTimeZone={this.handleChangeStartTimeZone}
									handleChangeEndTimeZone={this.handleChangeEndTimeZone}
									handleChangeUnitPrice={this.handleChangeUnitPrice}
									handleToggleSwitch={this.handleToggleSwitch}
								/>
							)
						})}
					</div>
				break;
		}

		switch (this.state.tab) {
			case 'weekday':
				dynamic_price_chart =
					<div id="unit_price_day_chart" style={unit_price_chart_style}>
						<Unit_Price_Chart
							info={this.state.weekday}
						/>
					</div>
				break;
			case 'holiday':
				dynamic_price_chart =
					<div id="unit_price_day_chart" style={unit_price_chart_style}>
						<Unit_Price_Chart
							info={this.state.holiday}
						/>
					</div>
				break;
		}

		return (
			<div style={style}>
				<div id='main_content' style={main_content_style} className='slideInDown noScrollBar'>
					<Top_Bar
						width={this.props.width}
						title={this.props.receiver.getString('unit_price_settings')}
						left_button_type={'back'}
						handleLeftButton={this.handlePrevious}
					/>

					<div style={{ overflow: 'auto', height: this.props.height - 131 }}>

						{/* Currency Input */}
						<div style={{ textAlign: 'center' }}>
							<Editbox id='currency' style={{ width: this.props.width - 40, margin: 'auto' }} placeholder={this.props.receiver.getString('currency')} inputType='text' onChange={(event) => this.handleChangeCurrency(event.target.value)} value={this.state.currency} />
						</div>

						{dynamic_price_chart}

						{/* Tabs */}
						<div style={{ width: '100%', padding: 0, display: 'table', }}>
							<span style={{ cursor: 'pointer', display: 'table-cell', verticalAlign: 'middle', marginLeft: 0, maxheight: 40, width: '50%', padding: '10px 0px', textAlign: 'center', backgroundColor: this.state.tab == 'weekday' ? Colours.appBlue : 'white', color: this.state.tab == 'weekday' ? 'white' : 'black' }} onClick={() => this.handleShowPriceInfo('weekday')}>{this.props.receiver.getString('weekday')}</span>
							<span style={{ cursor: 'pointer', display: 'table-cell', verticalAlign: 'middle', marginLeft: 0, maxheight: 40, width: '50%', padding: '10px 0px', textAlign: 'center', backgroundColor: this.state.tab == 'holiday' ? Colours.appBlue : 'white', color: this.state.tab == 'holiday' ? 'white' : 'black' }} onClick={() => this.handleShowPriceInfo('holiday')}>{this.props.receiver.getString('holiday')}</span>
						</div>

						{dynamic_content}

					</div>

				</div>
			</div>
		)
	}
}